export const FETCH_SEARCH_DETAILS_SUCCESS = "FETCH_SEARCH_DETAILS_SUCCESS";
export const FETCH_SEARCH_DETAILS = "FETCH_SEARCH_DETAILS";
export const QUICK_TELLER_USER = "QUICK_TELLER_USER";